
export const CloneData = [
    {
        id:1,
        name:"Adobe Clone",
        tags:["html","css","javascript"],
        date:"13 May, 2021",
        imgSrc:"http://www.keysys.com/wp-content/uploads/2016/01/Adobe-Banner-1.png",
        link:"https://github.com/777ahesh/frontendclone/tree/main/Adobe%20Website%20Clone"
    },
    {
        id:2,
        name:"Discord Dashboard Clone",
        tags:["html","css","javascript"],
        date:"5 July, 2021",
        imgSrc:"https://piunikaweb.com/wp-content/uploads/2019/11/discord-app-1.jpg",
        link:"https://github.com/777ahesh/frontendclone/tree/main/Discord_App_Clone"
    },
    {
        id:3,
        name:"Netflix Website Clone",
        tags:["html","css","javascript"],
        date:"6 July, 2021",
        imgSrc:"https://www.oracleglobe.com/wp-content/uploads/2021/04/Screenshot-2021-04-29-at-23.54.05.png",
        link:"https://github.com/777ahesh/frontendclone/tree/main/Netflix%20Clone"
    },
    {
        id:4,
        name:"Google Search Clone",
        tags:["html","css","javascript"],
        date:"26 May, 2021",
        imgSrc:"https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Google_web_search.png/1280px-Google_web_search.png",
        link:"https://github.com/777ahesh/frontendclone/tree/main/Google%20UI%20Clone"
    },
    {
        id:5,
        name:"Youtube UI Clone",
        tags:["html","css","javascript"],
        date:"3 Feb, 2021",
        imgSrc:"https://www.wikihow.com/images/thumb/5/5d/Embed-a-YouTube-Video-Step-1-Version-5.jpg/v4-460px-Embed-a-YouTube-Video-Step-1-Version-5.jpg.webp",
        link:"https://github.com/777ahesh/frontendclone/tree/main/Youtube%20Clone"
    },
    {
        id:6,
        name:"Google Drive Clone",
        tags:["html","css","javascript"],
        date:"5 Jan, 2021",
        imgSrc:"https://ceblog.s3.amazonaws.com/wp-content/uploads/2022/07/30121850/googledrive1-min.png",
        link:"https://github.com/777ahesh/frontendclone/tree/main/Google%20Drive%20UI"

    },
   
    // {
    //     id:7,
    //     name:"What is Redux ? Simply Explained!",
    //     tags:["react","redux","javascript"],
    //     date:"16 May, 2021",
    //     imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--ZY1EK-Eo--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/bcz1u90oq3prr5fga3fs.png",
    //     link:"https://dev.to/codebucks/what-is-redux-simply-explained-2ch7"
    // },
    // {
    //     id:8,
    //     name:"How to create Sidebar navigation menu in ReactJS with react router and framer-motion",
    //     tags:["react","framer-motion","css"],
    //     date:"26 May, 2021",
    //     imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--rv4I8UwE--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/0a9h50milhlf1us6mn4a.png",
    //     link:"https://dev.to/codebucks/build-sidebar-navigation-menu-in-reactjs-with-react-router-and-framer-motion-for-cool-page-transition-effects-4bc3"
    // },
  
] 